import { default as documentfoldersTypes } from "./types";

const {
  ADD_DOCUMENTFOLDER_REQUEST,
  ADD_DOCUMENTFOLDER_SUCCESS,
  ADD_DOCUMENTFOLDER_FAILURE,
  FETCH_DOCUMENTFOLDERS_REQUEST,
  FETCH_DOCUMENTFOLDERS_SUCCESS,
  FETCH_DOCUMENTFOLDERS_FAILURE,
} = documentfoldersTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_DOCUMENTFOLDER_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case ADD_DOCUMENTFOLDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: "",
      };
    case ADD_DOCUMENTFOLDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_DOCUMENTFOLDERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_DOCUMENTFOLDERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_DOCUMENTFOLDERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
